__turbopack_context__.v({
  "label": "radio-module__slAlnq__label",
});
